import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import { API_URL } from '../config';
import { deviceId, rememberReferral } from '../lib/device';

/**
 * Переход по партнёрской ссылке: `/r/<код>`.
 *
 * Экран НИЧЕГО НЕ ПОКАЗЫВАЕТ дольше мгновения: по ссылке приходит человек,
 * которому обещали игры для эфира, а не рассказ о партнёрской программе.
 * Здесь засчитывается переход, код кладётся в браузер до регистрации - и
 * дальше обычная регистрация.
 *
 * КОД НЕ УХОДИТ В АДРЕС РЕГИСТРАЦИИ: адрес со следом партнёра человек
 * перешлёт дальше, и привод достанется не тому.
 */
export function ReferralScreen() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const value = code ?? '';

    if (value === '') {
      void navigate('/signup', { replace: true });

      return;
    }

    rememberReferral(value);

    /* Переход засчитывается на сервере, но регистрация его не ждёт: медленный
       ответ не должен держать человека на пустом экране. */
    void fetch(`${API_URL}/api/affiliate/click`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ code: value, device: deviceId() }),
    }).catch(() => null);

    void navigate('/signup', { replace: true });
  }, [code, navigate]);

  return (
    <p className="text-foreground/80 p-6 text-sm" role="status">
      Открываем регистрацию…
    </p>
  );
}
